module.exports = __webpack_public_path__ + "fd3d76a04a74c6302d529f1a886bf4f2.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/mug-white.png
// module id = 847
// module chunks = 0